import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import presents from "@irati-web/wallet/src/images/presents.svg"

export const PresentsImg = styled.img.attrs({alt: "", src: presents})`
  max-height: 265px;
  max-width: 265px;
`

export const LimitedDeal = styled.div`
  background: ${({theme}) => theme.colors.utility.promo};
  border-radius: 2px;
  padding: 4px 6px;
  width: fit-content;
`

export const Container = styled(Card)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({theme}) => css`
    gap: ${theme.spacing.two};
    background: linear-gradient(110deg, ${theme.colors.primary2} 50%, ${theme.colors.tertiary.p_400} 100%);

    ${theme.mediaQueries.minWidthMedia.tablet`
      background: linear-gradient(45deg, ${theme.colors.primary2} 0%, ${theme.colors.tertiary.p_400} 100%);
    `}
  `}
`
